import { getEditLocation } from "../../../core/util/functions";
export const guaranteeLocation = "/cliring/guaranteesmanagement";
export const getGuaranteeEditLocation = (id?: string) =>
  getEditLocation(guaranteeLocation, undefined, id);

export const editRouter = getGuaranteeEditLocation(":payId?");
